import { Sprout, Github, Twitter, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-border/60 bg-muted/30 mt-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <Link to="/" className="flex items-center gap-2 mb-4">
            <div className="h-9 w-9 rounded-2xl bg-primary text-primary-foreground flex items-center justify-center">
              <Sprout size={18} />
            </div>
            <span className="font-display text-xl font-bold">
              NeighborNet<span className="text-secondary"> AI</span>
            </span>
          </Link>
          <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
            Communities helping communities — one small act at a time, guided by intelligent matching.
          </p>
        </div>

        <div>
          <h4 className="font-display font-semibold mb-4 text-foreground">Platform</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/dashboard" className="hover:text-foreground">Dashboard</Link></li>
            <li><Link to="/volunteer" className="hover:text-foreground">Volunteer</Link></li>
            <li><Link to="/jobs" className="hover:text-foreground">Jobs & Gigs</Link></li>
            <li><Link to="/food" className="hover:text-foreground">Food Support</Link></li>
            <li><Link to="/mentorship" className="hover:text-foreground">Mentorship</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold mb-4 text-foreground">Get involved</h4>
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li><Link to="/post-need" className="hover:text-foreground">Post a need</Link></li>
            <li><Link to="/offer-help" className="hover:text-foreground">Offer help</Link></li>
            <li><Link to="/stats" className="hover:text-foreground">Impact stats</Link></li>
            <li><a href="#" className="hover:text-foreground">Partner with us</a></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display font-semibold mb-4 text-foreground">Follow</h4>
          <div className="flex gap-3">
            <a href="#" aria-label="Twitter" className="h-9 w-9 rounded-full bg-background border border-border flex items-center justify-center hover:bg-accent transition-colors">
              <Twitter size={16} />
            </a>
            <a href="#" aria-label="LinkedIn" className="h-9 w-9 rounded-full bg-background border border-border flex items-center justify-center hover:bg-accent transition-colors">
              <Linkedin size={16} />
            </a>
            <a href="#" aria-label="GitHub" className="h-9 w-9 rounded-full bg-background border border-border flex items-center justify-center hover:bg-accent transition-colors">
              <Github size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-border/60 py-5 text-center text-xs text-muted-foreground">
        © 2026 NeighborNet AI — Built with care for communities worldwide.
      </div>
    </footer>
  );
}
